// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__nUjpC","search":"Search_search__6ji7-"};